import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import AdminExportExcelByVpsUsComponent from "../../../../components/Admin/vps_us/AdminExportExcelByVpsUsComponent";

const AdminExportExcelVpsUsPage = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <AdminExportExcelByVpsUsComponent
        redirectBack={ () => redirectBack() }
        listVpsId={ new URLSearchParams(search).get('listVpsId') }
    />
}

export default AdminExportExcelVpsUsPage;